export default "__VITE_ASSET__BPtcO9Op__"